import React, { useEffect, useState } from 'react';
import { addDoc, collection, getDocs, query, where } from 'firebase/firestore';
import { Link, useNavigate } from 'react-router-dom';
import { BsCheck2Circle } from 'react-icons/bs';
import { FaAnglesLeft } from 'react-icons/fa6';
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { auth, db, storage } from '../../../firebase';
import Modal from '../../../components/Modal/Modal';


function NewMember() {

    const [type, setType] = useState('');

    const [jobtitle, setJobtitle] = useState('');
    const [directLink, setDirectLink] = useState('');
    const [location, setLocation] = useState('');

    const [name, setName] = useState('');
    const [actualPosition, setActualkPosition] = useState('');
    const [profilPicture, setProfilPicture] = useState('');
    const [websiteLink, setWebsiteLink] = useState('');
    const [igHandle, setIgHandle] = useState('');




    const user = auth.currentUser;
    //Récupérer les données de l'utilisateur
    const [userData, setUserData] = useState(null);

    useEffect(() => {
        const fetchUserData = async () => {
            const q = query(collection(db, "users"),
                where("email", "==", user.email))
            const querySnapshot = await getDocs(q);
            querySnapshot.forEach((doc) => {
                setUserData(doc.data());
            })
        };
        fetchUserData();
    }, [user]);

    const handleProfilPicture = (event) => {
        setProfilPicture(event.target.files[0]);
    };

    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
        navigate('/dashboard/');
    }

    const [isLoading, setIsLoading] = useState(false);

    const addNewMember = async (event) => {
        try {
            event.preventDefault();
            setIsLoading(true); // Afficher le loader

            // Télécharger la photo de profil sur Firebase Storage
            const fileRef = ref(storage, `profil_pictures/${profilPicture.name}`);
            await uploadBytes(fileRef, profilPicture);

            // Récupérer l'URL de téléchargement de la photo de profil
            const profilPictureUrl = await getDownloadURL(fileRef);

            // Adding the article to Firebase Firestore
            await addDoc(collection(db, "team"), {
                type: type,
                name: name,
                profilPicture: profilPictureUrl,
                actualPosition: actualPosition,
                websiteLink: websiteLink,
                igHandle: igHandle,
                author: userData?.displayName,
                isVisible: true,
                createdAt: new Date(),
            });

            setIsLoading(false);

            setOpen(true)

            setJobtitle('');

        } catch (error) {
            setIsLoading(false);
            console.error("Error adding article: ", error);
        }
    };

    const addNewJobOffer = async (event) => {
        try {
            event.preventDefault();
            setIsLoading(true); // Afficher le loader

            // Adding the article to Firebase Firestore
            await addDoc(collection(db, "team"), {
                type: type,
                jobtitle: jobtitle,
                location: location,
                directLink: directLink,
                author: userData?.displayName,
                isVisible: true,
                createdAt: new Date(),
            });

            setIsLoading(false);

            setOpen(true)

            setJobtitle('');

        } catch (error) {
            setIsLoading(false);
            console.error("Error adding article: ", error);
        }
    };

    const navigate = useNavigate();

    return (

        <div id='newArticle' className='px-[60px]'>

            <section className="flex pb-[30px]" id='blog'>

                <div className="xl:flex hidden justify-start items-center">
                    <Link onClick={() => navigate(-1)} className="font-pressura flex items-center text-aqua text-[14px]">
                        <FaAnglesLeft className='text-[10px]' />
                        Back
                    </Link>
                </div>

            </section>

            <div className='flex justify-center w-full'>

                <div className='font-agrandir w-full'>
                    <form action="">
                        <div className='form-ctrl'>
                            <label><p className=''>Type de poste</p></label>
                            <select
                                value={type}
                                onChange={(e) => setType(e.target.value)}
                                required>
                                <option >-Sélectionner le type de membre-</option>
                                <option value="member">Membre de l'équipe</option>
                                <option value="hiring">Offre d'emploi</option>
                            </select>
                        </div>
                    </form>


                    {type === 'member' &&

                        <form className="" onSubmit={addNewMember}>

                            <div className='form-ctrl'>
                                <label><p>Nom</p></label>
                                <input type="text"
                                    className='outline-none border-2 px-4 py-2 rounded-md w-full'
                                    value={name}
                                    onChange={(event) => setName(event.target.value)}
                                    required
                                />
                            </div>

                            <div className='form-ctrl'>
                                <label><p className=''>Photo de profil</p></label>
                                <input type="file"
                                    onChange={handleProfilPicture}
                                    required
                                />
                            </div>

                            <div className='form-ctrl'>
                                <label><p>Poste occupé</p></label>
                                <input type="text"
                                    className='outline-none border-2 px-4 py-2 rounded-md w-full'
                                    value={actualPosition}
                                    onChange={(event) => setActualkPosition(event.target.value)}
                                    required
                                />
                            </div>

                            <div className='form-ctrl'>
                                <label><p>Lien vers site internet</p></label>
                                <input type="text"
                                    className='outline-none border-2 px-4 py-2 rounded-md w-full'
                                    value={websiteLink}
                                    onChange={(event) => setWebsiteLink(event.target.value)}
                                    required
                                />
                            </div>

                            <div className='form-ctrl'>
                                <label><p>Instagram Handle (without @)</p></label>
                                <input type="text"
                                    className='outline-none border-2 px-4 py-2 rounded-md w-full'
                                    value={igHandle}
                                    onChange={(event) => setIgHandle(event.target.value)}
                                    required
                                />
                            </div>

                            <div className='btn-ctrl'>
                                <button className="buttonviolet w-[200px!important]">
                                    {isLoading ? (
                                        <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                        </svg>
                                    ) : (
                                        <p>Sauvegarder</p>
                                    )}
                                </button>
                            </div>

                        </form>

                    }

                    {type === 'hiring' &&

                        <form className="" onSubmit={addNewJobOffer}>

                            <div className='form-ctrl'>
                                <label><p>Intitulé du poste</p></label>
                                <input type="text"
                                    className='outline-none border-2 px-4 py-2 rounded-md w-full'
                                    value={jobtitle}
                                    onChange={(event) => setJobtitle(event.target.value)}
                                    required
                                />
                            </div>

                            <div className='form-ctrl'>
                                <label><p>Ville, Pays</p></label>
                                <input type="text"
                                    className='outline-none border-2 px-4 py-2 rounded-md w-full'
                                    value={location}
                                    onChange={(event) => setLocation(event.target.value)}
                                    required
                                />
                            </div>

                            <div className='form-ctrl'>
                                <label><p>Lien direct vers l'offre d'emploi</p></label>
                                <input type="text"
                                    className='outline-none border-2 px-4 py-2 rounded-md w-full'
                                    value={directLink}
                                    onChange={(event) => setDirectLink(event.target.value)}
                                    required
                                />
                            </div>

                            <div className='btn-ctrl'>
                                <button className="buttonviolet w-[200px!important]">
                                    {isLoading ? (
                                        <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                        </svg>
                                    ) : (
                                        <p>Publier l'offre</p>
                                    )}
                                </button>
                            </div>

                        </form>
                    }





                </div>

            </div>

            {open &&
                <Modal isOpen={open} onClose={handleClose}>
                    <center>
                        <div className='flex flex-col gap-4 items-center justify-center'>
                            <BsCheck2Circle className='text-green-700 text-[50px]' />

                            <p>Nouveau membre ajouté !</p>

                            <button
                                className='buttonviolet'
                                type='submit'
                                onClick={handleClose}
                            >OK</button>

                        </div>
                    </center>
                </Modal>
            }

        </div>

    )
}

export default NewMember